import { Component, HostBinding } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { slide } from 'src/app/animations/transicion';
import { Settings } from 'src/app/interfaces/globals';
import { Navigation } from 'src/app/utils/navigation';

declare var SETTINGS : Settings;

@Component({
	selector: 'YompMobileComponent',
	templateUrl: './yomp-mobile.component.html',
	styleUrls: ['./yomp-mobile.component.css'],
  animations: [slide]
})
export class YompMobileComponent {

	@HostBinding('@routeAnimation') routeAnimation = true;

	platform : object = { platform : "mobile" };

	constructor(private _router : Router, private _activatedRoute : ActivatedRoute) { }

	protected _navigation = new Navigation(this._router, this._activatedRoute);

	/**
	 * Get the Yomp Mobile play store url.
	 *
	 * @memberof YompMobileComponent
	 */
	getYompMobilePlayStoreUrl() : void {

		window.open(SETTINGS.PLAY_STORE.YOMP_MOBILE, '_blank');

	}

}